import {
  REGISTER_USER,
  SIGNIN_USER,
  MIDDLEWARE_ON,
  MIDDLEWARE_OFF,
  ADD_DASHBOARD_NAME,
} from "../Constants/types";

const initialState = {
  UserTokenData: [],
  isLogin: false,
  middlewareActivated: false,
  dashboardName: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REGISTER_USER:
      return {
        ...state,
        UserTokenData: action.payload,
      };
    case SIGNIN_USER:
      // console.log(action);
      return {
        ...state,
        UserTokenData: action.payload,
        isLogin: true,
      };

    case MIDDLEWARE_ON:
      return {
        ...state,
        middlewareActivated: true,
      };

    case MIDDLEWARE_OFF:
      return {
        ...state,
        middlewareActivated: false,
      };
    case ADD_DASHBOARD_NAME:
      return {
        ...state,
        dashboardName: action.payload,
      };
    default:
      return state;
  }
}
